export default "__VITE_ASSET__FbiIjSzd__"